import React from 'react'
import Link from 'next/link'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown'
import { ProfileAvatar } from './ProfileAvatar'
import { useTranslation } from '@/localization/useTranslation'
import { useProfileCompleteness } from '@/hooks/users/useProfileCompleteness'
import { PROFILE_PERSONAL_INFO_PATH } from '@/constants/profileCompleteness'

import classes from '../styles.module.scss'

interface AuthDropdownProps {
  isLoggedIn: boolean
  profileName?: string
  pathname: string
  onLogout: () => void
}

export const AuthDropdown: React.FC<AuthDropdownProps> = ({
  isLoggedIn,
  profileName,
  pathname,
  onLogout
}) => {
  const { t } = useTranslation()
  const { shouldShowIndicator } = useProfileCompleteness()
  if (!isLoggedIn) {
    return (
      <Link
        href='/login'
        className={classes.item}
        data-testid="component-navbar-login-item"
      >
        {t('Log in')}
        <div className={classes.item__underline} />
      </Link>
    )
  }

  return (
    <div className={classes.dropdown}>
      <span className={classes.dropdown__text}>
        <ProfileAvatar profileName={profileName} />
        <FontAwesomeIcon
          className={classes.dropdown__icon}
          size='sm'
          icon={faChevronDown}
        />
      </span>
      <ul className={classes.dropdown__list}>
        {shouldShowIndicator &&
          <Link
            href={PROFILE_PERSONAL_INFO_PATH}
            className={classNames({
              [classes.dropdown__item]: true,
              [classes.dropdown__incomplete]: true
            })}
          >
            <li>
              <span className={classes.dropdown__dot} />
              {t('Complete your profile')}
              <div className={classes.item__underline} />
            </li>
          </Link>
        }
        <Link
          href='/profile'
          className={classNames({
            [classes.dropdown__item]: true,
            [classes.item__active]: pathname === '/profile'
          })}
        >
          <li>
            {t('Profile')}
            <div className={classes.item__underline} />
          </li>
        </Link>
        <div onClick={onLogout} className={classes.dropdown__item}>
          <li>
            {t('Logout')}
            <div className={classes.item__underline} />
          </li>
        </div>
      </ul>
    </div>
  )
}
